import ai_automation_img_1 from "../assets/images/ai_automation/ai-automation-img-1.png";
import ai_automation_img_2 from "../assets/images/ai_automation/ai-automation-img-2.png";
import ai_automation_img_3 from "../assets/images/ai_automation/ai-automation-img-3.png";
import ai_automation_img_4 from "../assets/images/ai_automation/ai-automation-img-4.png";
import ai_automation_img_5 from "../assets/images/ai_automation/ai-automation-img-5.png";
import SectionTitle from "../reusable/SectionTitle";
import AnimateOnDisplay from "../reusable/AnimateOnDisplay";
import React, { useEffect, useId, useRef, useState } from "react";
// eslint-disable-next-line no-unused-vars
import CustomizedTooltips from "./CustomizedTooltips";
import { ClickAwayListener } from "@mui/material";

const carouselData = [
  {
    title: "الذكاء الاصطناعي التحاوري ووكلاء العناية الذاتية",
    description:
      "تمكين الشركات من تقديم الدعم الذكي للعملاء على مدار الساعة وطوال أيام الأسبوع من خلال روبوتات دردشة صوتية ودردشة آلية، وهذا يقلل من الاعتماد على العنصر البشري، ويحسِّن مستوى رضا العملاء، ويزيد من مشاركة العملاء دون عناء.",
    image: ai_automation_img_1,
  },
  {
    title: "المحتوى المُنشأ بالذكاء الاصطناعي وأتمتة التسويق",
    description:
      "تحول شركة Planet Beyond الأفكار إلى إعلانات تعتمد على الذكاء الاصطناعي تتسم بالجودة العالية وإلى أعمال فنية إبداعية حيث تنبض حملات الفيديو واللافتات الإعلانية واللوحات الإعلانية والصور في وسائل التواصل الاجتماعي بالحياة بفضل الصور الرمزية البشرية النابضة بالحياة والتوليف الصوتي الدقيق للذكاء الاصطناعي. حلولنا تتيح السرعة في الإنتاج والتوفير في تكاليف التسويق مع مساعدة الشركات على توسيع نطاق الانتشار وتعزيز المشاركة والتواصل مع الجماهير بفاعلية أكبر.",
    image: ai_automation_img_3,
  },
  {
    title: "الأتمتة الذكية لسير العمل",
    description:
      "يمكنك إحداث ثورة في عملياتك باستخدام الأتمتة القائمة على الذكاء الاصطناعي والمصممة لمجال عملك بشكل خاص ودقيق. فبداية من لوحات المعلومات الذكية وأتمتة المهام وصولاً إلى مساعدي الذكاء الاصطناعي الذين يعملون على تبسيط تفاعلات العملاء، فكل الحلول التي نقدمها هذه تعمل على تقليل التكاليف وتعزيز الكفاءة وتسريع عملية اتخاذ القرار في عمليات الاتصالات والإعلام والمؤسسات.",
    image: ai_automation_img_2,
  },
  {
    title: "التخصيص والذكاء التنبؤي",
    description:
      "إعادة تعريف كيفية فهم الشركات جمهورها ودعم مشاركته. فبفضل الدعم المتقدم من التحليل الذكي للبيانات وتعلم الآلة، تتوقع أنظمتنا احتياجات العملاء، وتتكيف معها آنيًا، وتحسِّن من مستوى المشاركة، وكل هذا يؤدي إلى زيادة الولاء والدقة والنمو القابل للقياس.",
    image: ai_automation_img_4,
  },
  {
    title: "الابتكار في الذكاء الاصطناعي الصوتي واللغوي",
    description:
      "تُعيد شركة Planet Beyond تعريف طبيعة التفاعل بين الإنسان والآلة من خلال الذكاء الاصطناعي الصوتي واللغوي المتقدم، ودمج تقنية تحويل الكلام إلى نص (STT) للتعرف الدقيق على الكلام، والنماذج اللغوية الكبيرة (LLM) للفهم الذكي، وتحويل النص إلى كلام (TTS) للاستجابات الطبيعية الشبيهة بالاستجابات البشرية. يعمل هذا الإطار على تشغيل المساعد الصوتي، والتنقل الصوتي، والمحادثات باللغات المتعددة التي تعزز التفاعل، وتيسير الوصول، وتحويل التفاعلات الرقمية",
    image: ai_automation_img_5,
  },
];

export default function AIAutomationCarousel() {
  return (
    <div id="aiAutomation" className="bg-white min-h-svh py-16 px-8-">
      {/* Header */}
      <div className="text-center  space-y-10 mb-12">
        <SectionTitle
          className={"text-center font-40-to-108 bg-red-500-"}
          firstChild={
            <p
              dir="rtl"
              className="leading-none text-left- font-[300] text-[#111748] uppercase"
            >
              الذكاء الاصطناعي
            </p>
          }
          secondChild={
            <p
              dir="rtl"
              className="text-right- font-[900] leading-none text-[#111748] uppercase"
            >
              والأتمتة{" "}
            </p>
          }
          viewPortStartPointFromBottom={0}
          viewPortEndPointFromBottom={50}
          firstChildTranslateAtStart={window.innerWidth * 0.3}
        />
        <AnimateOnDisplay
          animationClass={"paragraph-animation"}
          screenPercentHeightToStartAnimation={90}
          className={"opacity-0"}
          animateEveryTime={false}
        >
          <p
            dir="rtl"
            className="text-[16px] tablet:text-[22px] laptop:text-[28px] desktop:text-[34px] font-[200] text-center mx-[10%] laptop:mx-[13.33%]"
          >
            لدينا في Planet Beyond اعتقاد متجذر بأن الذكاء الاصطناعي لا يقف عند
            كونه مجرد تقنية، وإنما هو تحوّل شامل. ومن ثم، فإن خبرتنا في إنشاء
            المحتوى بالذكاء الاصطناعي ووكلاء الذكاء الاصطناعي المخصصين تُمكِّن
            الشركات في الصناعات المتعددة من إعادة بلورة مفهوم المشاركة وتسريع
            النمو والبقاء في المقدمة في عالم رقمي دائم التطور.
          </p>
        </AnimateOnDisplay>
      </div>

      {/* Carousel */}
      <div className="mt-16">
        <Carousel dataSize={carouselData.length}>
          {carouselData.map((item, index) => (
            <CarouselCard key={index} data={item} />
          ))}
        </Carousel>
      </div>
    </div>
  );
}

export const Carousel = ({
  shadowLeft,
  shadowRight,
  dataSize = 5,
  children,
  // isSoftwareSolutions = false,
}) => {
  const cardsSectionId = useId();
  const containerRef = useRef(null);
  const [isGrabbing, setIsGrabbing] = useState(false);
  const [scrollDirection, setScrollDirection] = useState(true);
  const [isScrolling, setIsScrolling] = useState(true);
  const refs = useRef([...Array(dataSize)].map(() => React.createRef()));
  const [renderCount, forceRender] = useState(0);
  const triggerCheck = () => forceRender((v) => v + 1);
  const dragState = useRef({ startX: 0, startScrollLeft: 0 });

  const getClientX = (e) => {
    if (e.touches && e.touches[0]) return e.touches[0].pageX;
    if (e.changedTouches && e.changedTouches[0])
      return e.changedTouches[0].pageX;
    return e.pageX ?? e.clientX;
  };

  const handleGrabStart = (e) => {
    if (!containerRef.current) return;
    setIsGrabbing(true);
    setIsScrolling(false);

    const x = getClientX(e) - containerRef.current.offsetLeft;
    dragState.current.startX = x;
    dragState.current.startScrollLeft = containerRef.current.scrollLeft;

    window.addEventListener("mouseup", handleGrabEnd);
    window.addEventListener("touchend", handleGrabEnd, { passive: true });
  };

  const handleGrabEnd = () => {
    setIsGrabbing(false);
    window.removeEventListener("mouseup", handleGrabEnd);
    window.removeEventListener("touchend", handleGrabEnd);
  };

  const handlePointerMove = (e) => {
    if (!isGrabbing || !containerRef.current) return;
    if (e.cancelable) e.preventDefault();

    const x = getClientX(e) - containerRef.current.offsetLeft;
    const walk = x - dragState.current.startX;
    containerRef.current.scrollLeft = dragState.current.startScrollLeft - walk;
  };

  // const horizontalScroll = () => {
  //   const maxScrollLeft =
  //     containerRef.current.scrollWidth - containerRef.current.clientWidth;
  //   if (scrollDirection) {
  //     containerRef.current.scrollLeft += 1;
  //     if (containerRef.current.scrollLeft >= maxScrollLeft) {
  //       console.log(
  //         "🟢 END reached:",
  //         "scrollLeft =",
  //         containerRef.current.scrollLeft,
  //         "| maxScrollLeft =",
  //         maxScrollLeft,
  //         "| clientWidth =",
  //         containerRef.current.clientWidth,
  //         "| scrollWidth =",
  //         containerRef.current.scrollWidth,
  //         "| time =",
  //         new Date().toLocaleTimeString()
  //       );
  //       setScrollDirection(false);
  //     }
  //   } else {
  //     containerRef.current.scrollLeft -= 1;
  //     if (containerRef.current.scrollLeft <= 0) {
  //       console.log(
  //         "🔵 START reached:",
  //         "scrollLeft =",
  //         containerRef.current.scrollLeft,
  //         "| maxScrollLeft =",
  //         maxScrollLeft,
  //         "| time =",
  //         new Date().toLocaleTimeString()
  //       );
  //       setScrollDirection(true);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   if (!isSoftwareSolutions) return; // keep legacy behavior for other carousels
  //   const el = containerRef.current;
  //   if (!el) return;

  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       const entry = entries[0];
  //       if (entry.isIntersecting) {
  //         setIsScrolling(true);
  //       } else {
  //         setIsScrolling(false);
  //       }
  //     },
  //     {
  //       root: null,
  //       // Start as soon as ~25% of the section is visible; tweak if needed
  //       threshold: 0.25,
  //     }
  //   );
  //   observer.observe(el);
  //   return () => observer.disconnect();
  // }, [isSoftwareSolutions]);

  const horizontalScroll = () => {
    const el = containerRef.current;
    if (!el) return;

    // Tuning knobs
    const STEP = 1; // slightly larger than 1 to beat rounding at 125% zoom
    const EPS = 2; // tolerance & "edge nudge" in pixels

    const maxScrollLeft = Math.max(0, el.scrollWidth - el.clientWidth);

    if (scrollDirection) {
      // → move right
      el.scrollLeft = Math.min(el.scrollLeft + STEP, maxScrollLeft);

      // Edge detection with tolerance
      if (maxScrollLeft - el.scrollLeft <= EPS) {
        // Nudge off the hard edge before reversing
        el.scrollLeft = Math.max(0, maxScrollLeft - EPS);
        setScrollDirection(false);
      }
    } else {
      // ← move left
      el.scrollLeft = Math.max(el.scrollLeft - STEP, 0);

      // Edge detection with tolerance
      if (el.scrollLeft <= EPS) {
        // Nudge off the hard edge before reversing
        el.scrollLeft = Math.min(EPS, maxScrollLeft);
        setScrollDirection(true);
      }
    }
  };

  useEffect(() => {
    let intervalId = null;
    const allChildrenPopupClosed = refs.current.every(
      (ref) => ref.current === false
    );

    if (isScrolling && allChildrenPopupClosed) {
      intervalId = setInterval(horizontalScroll, 10);
    } else {
      intervalId = setInterval(triggerCheck, 100);
    }
    return () => {
      clearInterval(intervalId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isScrolling, scrollDirection, renderCount]);

  useEffect(() => {
    const sectionCardsElement = document.getElementById(cardsSectionId);
    sectionCardsElement.addEventListener("mouseleave", startScrolling);
    sectionCardsElement.addEventListener("mouseenter", stopScrolling);
    sectionCardsElement.addEventListener("touchend", startScrolling);
    sectionCardsElement.addEventListener("touchstart", stopScrolling);
    return () => {
      sectionCardsElement.removeEventListener("mouseleave", startScrolling);
      sectionCardsElement.removeEventListener("mouseenter", stopScrolling);
      sectionCardsElement.removeEventListener("touchend", startScrolling);
      sectionCardsElement.removeEventListener("touchstart", stopScrolling);
    };
  }, [cardsSectionId]);

  const startScrolling = () => {
    setIsScrolling(true);
  };
  const stopScrolling = () => {
    setIsScrolling(false);
  };
  const enhancedChildren = React.Children.map(children, (child, index) =>
    React.cloneElement(child, {
      ref: refs.current[index],
    })
  );
  return (
    <div className="relative flex-grow overflow-x-auto hide-scroll-bar overflow-y-hidden">
      {" "}
      {shadowLeft && (
        <div className="absolute top-0 left-0 h-full w-2 tablet:w-6 laptop:w-10 bg-gradient-to-r from-[#ECECF0] to-[#ECECF000] from-70% z-50"></div>
      )}{" "}
      {shadowRight && (
        <div className="absolute top-0 right-[-4px] laptop:right-0 h-full w-2 tablet:w-6 laptop:w-10 bg-gradient-to-l from-[#ECECF0] from-70% z-50"></div>
      )}{" "}
      <div
        id={cardsSectionId}
        className={`${
          isGrabbing ? "cursor-grabbing" : "cursor-grab"
        } overflow-x-auto hide-scroll-bar overflow-y-hidden`}
        ref={containerRef}
        onMouseDown={handleGrabStart}
        onMouseMove={handlePointerMove}
        onMouseUp={handleGrabEnd}
        onMouseLeave={handleGrabEnd}
        onTouchStart={handleGrabStart}
        onTouchMove={handlePointerMove}
        onTouchEnd={handleGrabEnd}
      >
        {shadowLeft && <div className="h-full w-20 text-transparent">ssss</div>}
        <div className="flex gap-0 relative py-13">{enhancedChildren}</div>
      </div>
    </div>
  );
};

const CarouselCard = React.forwardRef(({ data }, ref) => {
  const { title, description, image } = data;
  const [isToolTipOpen, setToolTipOpen] = useState(false);
  useEffect(() => {
    ref.current = isToolTipOpen;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isToolTipOpen]);

  const handleToggleToolTip = () => setToolTipOpen((prev) => !prev);
  const handleToolTipClose = () => setToolTipOpen(false);

  const subDescription = description.slice(0, 91);
  return (
    <div
      className="
    w-[22em] laptop:w-[30em] desktop:w-[40em] 
    min-w-[22em] laptop:min-w-[30em] desktop:min-w-[40em]
    max-w-[22em] laptop:max-w-[30em] desktop:max-w-[40em]
     select-none mx-px"
    >
      <div className="aspect-[639/488] relative">
        <img
          src={image}
          alt=""
          draggable="false"
          className="select-none pointer-events-none"
        />
        {isToolTipOpen && (
          <div
            dir="rtl"
            className={`absolute z-[99] bottom-[-6.25rem] left-1/2 -translate-x-1/2 triangle-bottom
          bg-[#efefef] text-[#11174899] 
            px-[30px] py-[36px] text-[22px] min-w-[536px]
            max-[960px]:px-[20px] max-[960px]:py-[24px] max-[960px]:text-[18px] max-[960px]:min-w-[32vw]
            max-[576px]:px-[16px] max-[576px]:py-[18px] max-[576px]:text-[16px] max-[576px]:min-w-[21.5em]
            select-none
          `}
          >
            {description}
          </div>
        )}
      </div>
      <div className="mt-9 mx-6 gap-4 flex flex-col justify-between items-start h-full-">
        <p
          dir="rtl"
          title={title}
          className="text-[#111748] font-black text-[22px] tablet:text-[25px] truncate- w-[100%] select-none"
        >
          {title}
        </p>
        <div
          dir="rtl"
          className="text-[16px] tablet:text-[18px] laptop:text-[20px] desktop:text-[22px] leading-4- text-[#11174899] select-none"
        >
          {subDescription} ...
          <ClickAwayListener onClickAway={handleToolTipClose}>
            <button
              dir="rtl"
              onClick={handleToggleToolTip}
              className="text-[#18A6AB] hover:bg-gray-400/5 px-2"
            >
              قراءة المزيد{" "}
            </button>
          </ClickAwayListener>
          {/* <CustomizedTooltips note={description} /> */}
        </div>
      </div>
    </div>
  );
});
